import type { Tagged } from "@-/com.npmjs.type-fest";
import { usePathname } from "@-/com.npmjs.expo-router";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import { useOnboardingState } from "@-/dev.improve.haniverse.lib.onboarding";
import {
  getOnboardingSheetSubject,
  type OnboardingSheetSubject,
} from "@-/dev.improve.haniverse.lib.onboarding.state";
import { getOnboardingPlace } from "#onboarding-place";

export type OnboardingSheetGate = Tagged<
  { subject: OnboardingSheetSubject },
  "OnboardingSheetGate"
>;

/**
 * The sheet shows while it has something to say where the learner is: the page's introduction, the
 * first time they open it, or a destination the onboarding has just unlocked.
 */
export function useOnboardingSheetGate(): OnboardingSheetGate | null {
  const subject = getOnboardingSheetSubject(
    useOnboardingState(),
    getOnboardingPlace(usePathname()),
  );
  return subject === null ? null : createGate<OnboardingSheetGate>({ subject });
}
